import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "./Button";
import { fmtNumber } from "../../lib/format";

export function Pagination({
  page,
  totalPages,
  total,
  from,
  to,
  busy,
  onChange,
}: {
  page: number;
  totalPages: number;
  total: number;
  from: number;
  to: number;
  busy: boolean;
  onChange: (p: number) => void;
}) {
  const windowSize = 5;
  const half = Math.floor(windowSize / 2);
  let start = Math.max(1, page - half);
  let end = Math.min(totalPages, start + windowSize - 1);
  if (end - start + 1 < windowSize) {
    start = Math.max(1, end - windowSize + 1);
  }
  const pages: number[] = [];
  for (let i = start; i <= end; i++) pages.push(i);

  return (
    <nav
      aria-label="Pagination"
      className="flex flex-col items-center justify-between gap-3 sm:flex-row"
    >
      <p className="text-xs text-gray-500 dark:text-gray-500">
        Showing{" "}
        <span className="tabular-nums text-gray-700 dark:text-gray-300">
          {fmtNumber(from)}–{fmtNumber(to)}
        </span>{" "}
        of{" "}
        <span className="tabular-nums text-gray-700 dark:text-gray-300">
          {fmtNumber(total)}
        </span>
      </p>

      <div className="flex items-center gap-1">
        <Button
          variant="secondary"
          disabled={page <= 1 || busy}
          onClick={() => onChange(page - 1)}
          className="!px-2 !py-1"
          aria-label="Previous page"
        >
          <ChevronLeft size={14} />
        </Button>

        {pages.map((p) => (
          <Button
            key={p}
            variant={p === page ? "primary" : "secondary"}
            disabled={busy}
            onClick={() => onChange(p)}
            className="!min-w-[36px] !px-2 !py-1 !text-xs tabular-nums"
            aria-current={p === page ? "page" : undefined}
          >
            {p}
          </Button>
        ))}

        <Button
          variant="secondary"
          disabled={page >= totalPages || busy}
          onClick={() => onChange(page + 1)}
          className="!px-2 !py-1"
          aria-label="Next page"
        >
          <ChevronRight size={14} />
        </Button>
      </div>
    </nav>
  );
}
